import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-validated-input',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslatePipe],
  templateUrl: './validated-input.component.html',
  styleUrl: './validated-input.component.scss',
})
export class ValidatedInputComponent {
  label = input<string>();
  inputFormControlName = input.required<string>();
  inputFormControl = input.required<FormControl>();
  validationTrainslations = input<{ [key: string]: string }>();
  leaveSpaceForValidation = input<boolean>(false);
  omitKeydownEnter = input<boolean>(false);
  placeholder = input<string>('');
  maxlength = input<number>();
  disabled = input<boolean>(false);
  type = input<'text' | 'email' | 'password'>('text');

  maxLengthValidator(): string | boolean {
    return (
      !this.maxlength || this.inputFormControl().value.length <= this.maxlength
    );
  }

  hasRequiredValidator(): string | boolean {
    return this.inputFormControl().hasValidator(Validators.required);
  }

  errorKeys(): string[] {
    const control = this.inputFormControl();
    return control.errors ? Object.keys(control.errors) : [];
  }

  getErrorMessage(errorKey: string): string {
    return this.validationTrainslations()?.[errorKey] ?? errorKey;
  }

  onEnterKey(event: Event): void {
    event.preventDefault();
  }
}
